<template>
  <div class="account">
    <div class="delete-account-content pt-4">
      <div>
        <b-row align-h="center">
          <b-col lg="9">
            <delete-account-progress-bar></delete-account-progress-bar>
          </b-col>
        </b-row>
        <delete-account-step-one
          v-if="!this.$route.query.q"
        ></delete-account-step-one>
        <delete-account-step-tow
          v-else-if="this.$route.query.q === 'check'"
        ></delete-account-step-tow>
        <delete-account-step-tree
          v-else-if="this.$route.query.q === 'confirmation'"
          :token="$route.query.token"
        ></delete-account-step-tree>
        <delete-account-step-four
          v-else-if="this.$route.query.q === 'close'"
        ></delete-account-step-four>
      </div>
    </div>
  </div>
</template>

<script>
import DeleteAccountProgressBar from "@/components/DeleteAccount/DeleteAccountProgressBar.vue";
import DeleteAccountStepFour from "@/components/DeleteAccount/DeleteAccountStepFour/DeleteAccountStepFour.vue";
import DeleteAccountStepOne from "@/components/DeleteAccount/DeleteAccountStepOne/DeleteAccountStepOne.vue";
import DeleteAccountStepTow from "@/components/DeleteAccount/DeleteAccountStepTow/DeleteAccountStepTow.vue";
import DeleteAccountStepTree from "@/components/DeleteAccount/DeleteAccountStepTree/DeleteAccountStepTree.vue";

export default {
  name: "DeleteAccount",
  components: {
    DeleteAccountProgressBar,
    DeleteAccountStepOne,
    DeleteAccountStepTow,
    DeleteAccountStepTree,
    DeleteAccountStepFour
  },
  beforeMount() {
    const token = localStorage.getItem("token") || null;
    if (!token) {
      this.$router.push({ name: 'Login', query: { da: "1" }   }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.delete-account-content {
  padding: 0 15px;
}
</style>
